module.exports = __webpack_public_path__ + "media/application/images/2022/magazine1-530de0ac4ebfe73d7da60bcaa92ce1fa.jpg";